
import Forsiden, { getSSRData } from 'src/lib/pages/ForsidenV2';

export const SECTION_ID = "filmnytt_v1";

//#region [Other]getServerSideProps
export const getServerSideProps = getSSRData(SECTION_ID, {
    pageTitle: "Filmnyheter - Filmweb",
    adSetup: "news",
    sponsorSetup: "articlesAndList",
    hasStickyBottomAd: true
});
//#endregion




//#region [Component]
export default Forsiden;
//#endregion